import React from "react";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

function NoDataFound() {
    return (
        <div className="box-description mav-risk-not-found null-body-detected-breach">
            <div className="row row-container">
                <div className="col-sm-3"></div>
                <div className="col-xs-12 col-sm-12 text-align-center col-main">
                    <RenderIcons iconName="info-circle" />
                    <div>
                        <div className="title-main mtb-1rem">No scans took place in the selected date range.</div>
                        <div className="description">To broaden your view of the scans please select a different date range.</div>
                    </div>
                </div>
                <div className="col-sm-3"></div>
            </div>
        </div>
    );
}

export default NoDataFound;
